import { BoardMember } from '../types';

export const slideshowImages = [
  {
    src: "/images/landing_page/WOPRChodziez1.webp",
    alt: "Drużyna WOPR Chodzież podczas akcji ratunkowej"
  },
  {
    src: "/images/landing_page/WOPRChodziez2.webp",
    alt: "Sprzęt ratowniczy WOPR Chodzież"
  },
  {
    src: "/images/landing_page/WOPRChodziez3.webp",
    alt: "Trening ratowników WOPR Chodzież na wodzie"
  },
  {
    src: "/images/landing_page/WOPRChodziez4.webp",
    alt: "Łódź ratownicza WOPR Chodzież"
  },
  {
    src: "/images/landing_page/WOPRChodziez5.webp",
    alt: "Ratownicy WOPR Chodzież podczas szkolenia"
  },
  {
    src: "/images/landing_page/WOPRChodziez6.webp",
    alt: "Baza WOPR Chodzież"
  },
  {
    src: "/images/landing_page/WOPRChodziez7.webp",
    alt: "Ratownik WOPR Chodzież na stanowisku"
  },
  {
    src: "/images/landing_page/WOPRChodziez8.webp",
    alt: "Plaża nad jeziorem pod nadzorem WOPR Chodzież"
  },
];

export const boardMembers: BoardMember[] = [
  {
    src: "/images/people/Bezy.png",
    alt: "Photo of Bezy",
    name: "Maciej",
    surname: "Bielecki",
    role: "board.roles.president"
  },
  {
    src: "/images/people/Tomek.png",
    alt: "Photo of Tomek",
    name: "Tomasz",
    surname: "Hepner",
    role: "board.roles.vice_president"
  },
  {
    src: "/images/people/Weronika.png",
    alt: "Photo of Weronika",
    name: "Weronika",
    surname: "Nowak",
    role: "board.roles.secretary"
  },
  {
    src: "/images/people/Majas.png",
    alt: "Photo of Majas",
    name: "Krzysztof",
    surname: "Majewski",
    role: "board.roles.treasurer"
  },
  {
    src: "/images/people/jedrzej-jozwiak.jpg",
    alt: "Jędrzej Jóźwiak",
    name: "Jędrzej",
    surname: "Jóźwiak",
    role: "board.roles.member"
  }
];